<template>
  <v-radio-group
    v-model="inputValue"
    v-bind:rules="citizenOrPassportRules"
    :mandatory="false"
    row
  >
    <v-row>
      <v-col cols="12" sm="6">
        <v-radio
          v-bind:label="$t('info_card.fill_thai_citizenID')"
          value="citizen"
        ></v-radio>
      </v-col>
      <v-col cols="12" sm="6">
        <v-radio
          v-bind:label="$t('info_card.fill_passport_number')"
          value="passport"
        ></v-radio>
      </v-col>
    </v-row>
  </v-radio-group>
</template>

<script>
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";
export default {
  name: "CitizenOrPassport",
  props: ["value"],
  methods: {
    objectTranslator,
  },
  data() {
    return {
      citizenOrPassportRules: [validator.required],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
